import { render, staticRenderFns } from "./LanguageList.vue?vue&type=template&id=b8966d3e&"
import script from "./LanguageList.vue?vue&type=script&lang=ts&"
export * from "./LanguageList.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports